module.exports = __webpack_public_path__ + "media/images/badge/campionato-bracket-perfetto_secondary-fd53b00fb8e0e71af52dcb8ca699bbe9.png";